'use client';

import { useState } from 'react';
import { NavItem } from '@/components/nav/Header';
import { useSupabase } from '@/components/providers/SupabaseProvider';
import { BurgerMenuLink } from '@/components/nav/BurgerMenuLink';
import SignUpButton from '@/components/buttons/SignUpButton';
import LogInButton from '@/components/buttons/LogInButton';

export default function BurgerMenu({ navItems }: { navItems: NavItem[] }) {
  const [isOpen, setIsOpen] = useState(false);
  const { session } = useSupabase();

  navItems = session ? navItems : navItems.slice(0, navItems.length - 1);

  return (
    <div className="lg:hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="relative z-20 h-10 w-10  text-gray-900 focus:outline-none dark:text-gray-100"
        aria-label="menu"
      >
        <div className="absolute left-1/2 top-1/2 block w-6   -translate-x-1/2  -translate-y-1/2 transform">
          <span
            aria-hidden="true"
            className={`absolute block h-0.5 w-6 transform bg-current transition duration-500 ease-in-out 
              ${isOpen ? 'rotate-45' : '-translate-y-1.5'}`}
          />
          <span
            aria-hidden="true"
            className={`absolute block h-0.5 w-6  transform bg-current transition duration-500 ease-in-out
              ${isOpen ? 'opacity-0' : ''}`}
          ></span>
          <span
            aria-hidden="true"
            className={`ease-in-out" +  absolute block h-0.5 w-6  transform bg-current transition duration-500
              ${isOpen ? '-rotate-45' : 'translate-y-1.5'}`}
          ></span>
        </div>
      </button>

      <div>
        <div
          onClick={() => setIsOpen(false)}
          className={`fixed left-0 top-0 h-full w-full bg-gray-900/40 ${
            isOpen ? '' : 'hidden'
          }`}
        />
        <div
          className={`fixed right-0 top-0
          flex
           h-full w-72 flex-col border 
           bg-white
           shadow-lg 
           transition-all duration-300 dark:border-none dark:bg-gray-900 ${
             isOpen ? '-translate-x-0' : 'translate-x-full'
           }`}
        >
          <div className="mt-16 flex flex-col">
            {navItems.map((item) => (
              <BurgerMenuLink
                key={item.label}
                item={item}
                callback={() => setIsOpen(false)}
              />
            ))}

            {!session && (
              <div className="ml-5 mt-3 space-y-2">
                <LogInButton />
                <SignUpButton />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
